import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import PayableListUI from '../../../components/superUser/transaction/PayableListUI'

const PayableListPageUI = ({
  context, account, errorList,
  onRefreshClick, payable,
  onCopyToClipboard, copyToClipboardText,
  showDetails, onShowDetails, selectedRowId,
  paySubmitted, paySuccessMsg, payErrorList, onPayClick,
  deleteSubmitted, deleteSuccessMsg, deleteErrorList, onDeleteClick
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_txns' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`} dimension='w768'
    centered={!account || !payable} account={account} page='payables'
  >
    {
      (!account || !payable) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      payable &&
      <PayableListUI
        context={context}
        account={account}
        payable={payable}
        onCopyToClipboard={onCopyToClipboard}
        copyToClipboardText={copyToClipboardText}
        onRefreshClick={onRefreshClick}
        showDetails={showDetails}
        onShowDetails={onShowDetails}
        selectedRowId={selectedRowId}
        paySubmitted={paySubmitted}
        paySuccessMsg={paySuccessMsg}
        payErrorList={payErrorList}
        onPayClick={onPayClick}
        deleteSubmitted={deleteSubmitted}
        deleteSuccessMsg={deleteSuccessMsg}
        deleteErrorList={deleteErrorList}
        onDeleteClick={onDeleteClick}
      />
    }
    {
      payable && payable.length === 0 &&
      <EmptyListUI className='g_m_top_200'
        context={context}
        createDisabledMessageLabel='No payment approvals'
      />
    }
  </SuperUserAccountPageUI>

export default PayableListPageUI
